/* eslint-disable no-unused-vars */
import classroom from '../state/modules/classroom'
import { collectionRef } from '../_services/firebase/db.js'

function findWithAttr(array, attr, value) {
  for (var i = 0; i < array.length; i += 1) {
    if (array[i][attr] === value) {
      return i
    }
  }
  return -1
}

var classroomMixin = {
  methods: {
    getClassrooms: async function (currentUserId, archivalStatus) {
      //console.log(store)
      //console.log(store.awards_store.currentSession.badges)
      console.log(archivalStatus)
      var classrooms = await collectionRef('classrooms')
        .where('creatorid', '==', currentUserId)
        .where('archived', '==', archivalStatus)
        .get()
        //.orderBy(orderCriteria).get()
        .then((querySnapshot) => {
          console.log(querySnapshot)
          var docarray = []
          querySnapshot.forEach((doc) => {
            // doc.data() is never undefined for query doc snapshots
            //  console.log(doc.id, " => ", doc.data());
            console.log(doc.id)
            var doc_data = doc.data()
            doc_data.croom_id = doc.id
            docarray.push(doc_data)
          })
          return docarray
        })
        .catch((error) => {
          console.log('Error getting documents: ', error)
        })
      console.log(classrooms)
      return classrooms
    },

    getClassroomInfoFromCode: async function (code) {
      //console.log(store)
      //console.log(store.awards_store.currentSession.badges)
      var codeAssignment = await collectionRef('codeAssigments')
        .where('registrationCode', '==', code)
        .get()
        //.orderBy(orderCriteria).get()
        .then((querySnapshot) => {
          console.log(querySnapshot)
          var docarray = []
          querySnapshot.forEach((doc) => {
            // doc.data() is never undefined for query doc snapshots
            //  console.log(doc.id, " => ", doc.data());
            docarray.push(doc.data())
          })
          return docarray
        })
        .catch((error) => {
          console.log('Error getting documents: ', error)
        })
      console.log(code)
      return codeAssignment
    },
    getCroomData: async function (currentCroomId, _orderCriteria) {
      var croom = await collectionRef('classrooms')
        .doc(currentCroomId)
        .get()
        .then((doc) => {
          if (doc.exists) {
            var doc_data = doc.data()
            doc_data.croom_id = doc.id

            return doc_data
          } else {
            // doc.data() will be undefined in this case
            console.log('No such document!')
          }
        })
        .catch((error) => {
          console.log('Error getting document:', error)
        })
      var croomStudents = await collectionRef('users')
        .where('classroom', '==', currentCroomId)
        .get()
        //.orderBy(orderCriteria).get()
        .then((querySnapshot) => {
          var docarray = []
          querySnapshot.forEach((doc) => {
            // doc.data() is never undefined for query doc snapshots
            //  console.log(doc.id, " => ", doc.data());
            var doc_data = doc.data()
            doc_data.user_id = doc.id
            doc_data.answers = {
              worlds_explored: 'no info',
              achievements: 'no info',
              missions: 'no info',
              points: 'no info'
            }
            docarray.push(doc_data)
          })
          return docarray
        })
        .catch((error) => {
          console.log('Error getting documents: ', error)
        })
      croom['students'] = croomStudents
      return croom
    },
    getAnswers: async function (studentsArray, orderCriteria) {
      console.log(studentsArray)
      let indexObject = {}
      let studentIds = studentsArray.map((a, index) => {
        // OyL4cuQsl7QZ3Bo8qs9A4ERT5jt2
        indexObject[a.user_id] = index
        return a.user_id
      })
      console.log(studentIds)
      console.log(indexObject)
      var croomStudents = await collectionRef('studentAnswers')
        .where('user_id', 'in', studentIds)
        .get()
        //.orderBy(orderCriteria).get()
        .then((querySnapshot) => {
          console.log(querySnapshot)
          var docarray = []
          querySnapshot.forEach((doc) => {
            // doc.data() is never undefined for query doc snapshots
            //  console.log(doc.id, " => ", doc.data());
            docarray.push(doc.data())
          })
          return docarray
        })
        .catch((error) => {
          console.log('Error getting documents: ', error)
        })

      console.log(croomStudents)
      croomStudents.map((a) => {
        const index = indexObject[a.user_id]
        console.log(index)
        console.log(studentsArray)
        studentsArray[index].answers = a
      })
      console.log(studentsArray)
      return studentsArray
    },
    /*getAnswer: async function (studentId, orderCriteria) {
      var croomStudents = await collectionRef('studentAnswers')
        .where('studentId', '==', studentId)
        .get()
        //.orderBy(orderCriteria).get()
        .then((querySnapshot) => {
          console.log(querySnapshot)
          var docarray = []
          querySnapshot.forEach((doc) => {
            // doc.data() is never undefined for query doc snapshots
            //  console.log(doc.id, " => ", doc.data());
            docarray.push(doc.data())
          })
          return docarray
        })
        .catch((error) => {
          console.log('Error getting documents: ', error)
        })
      console.log(croomStudents)
      croom['students'] = croomStudents
      console.log(croom)
      return croom
    },*/
    archiveClassroom: async function (classroomId, archivalStatus) {
      var classroomRef = await collectionRef('classrooms').doc(classroomId)

      // Set the "capital" field of the city 'DC'
      return classroomRef
        .update({
          archived: archivalStatus
        })
        .then(() => {
          console.log('Document successfully updated!')
        })
        .catch((error) => {
          // The document probably doesn't exist.
          console.error('Error updating document: ', error)
        })
    },


 
  }
}
export default classroomMixin

  
  